
module.exports = {
  menuList: {
    home: '首页',
    survey: '概况',
    service: '服务',
    exhibition: '展览',
    information: '资讯',
    collection: '典藏',
    socialEducation: '社教',
    culturalCreation: '文创',
    reSearch: '研究'
  },
  footterList: {
    huaianMuseumSummary: '靖博简介',
    WeaveConstruction: '组织结构',
    manager: '管理人员',
    decisionAndSupervisoryOrgan: '决策与监督机构',
    scholarshipCommittee: '学术委员会',

    serviceGuide: "服务指南",
    visit: '参观内容',
    volunteer: '志愿者',
    members: '会员之家',
    inspection: '观众调查',

    news: '新闻动态',
    partyBuilding: '靖博党建',
    ruleAndProject: '章程与规划',
    managerialSystem: '管理制度',
    muckle: '大事记',
    civilizationConstruction: '文明创建',

    standingExhibition: '常设展览',
    temporaryExhibition: '临时展览',
    abductionExchange: '外展交流',
    virtualWalkthrough: '虚拟漫游',

    culturalRelicToAppreciate: '文物鉴赏',
    choicestCollection: '精品典藏',

    potteryFigurine: '陶俑',
    culturalRelicsOf3D: '3D文物',
    ceramics: '陶瓷器',
    jadeWare: '玉石器',
    ironBronzeWare: '铁铜器',
    paintingAndCalligraphy: '书画',

    pedagogicalActivity: '教育活动',
    huaianMuseumRostrum: '靖博讲坛',

    culturalAndOriginalProduct: '文创产品',
    shopintroction: '商店介绍',

    academicResearch: '学术研究',
    collectionDatabase: '藏品数据库',
    learning: '学在靖博',

    academicWorks: '学术论著',
    dataIndexing: '资料引索',
    huaianHistory: '靖安历史',

  },
  sponsoredByHuaiMuseum: '主办单位：息烽集中营革命历史纪念馆',

  //首页
  onLineReserve: '线上预约',
  activityPreview: '活动预告',
  more: '更多',
  transportationGuide: '交通指南',
  huaianNews: '靖博新闻',
  excellentCollection: '馆藏精品',
  fujianDownload: '附件下载',
  //服务
  trafficRoute: '交通路线',
  busStation: '公交车站',
  address: '地    址',
  address1: '地       址',
  preliminaryInstructions: '参观须知',
  volunteerRules: '志愿者章程',
  volunteerDownload: '志愿者附件下载',
  societiesOfMuseumFriendsRoules: '博物馆之友章程',
  societiesOfMuseumFriendsDownload: '博物馆之友附件下载',
  //展览
  exhibitionCategory: '展览类别',
  exhibitionHall: '所在展厅',
  exhibitionTime: '展览时间',
  exhibitionAddress: '展览地点',
  organizer: '主办单位',
  exhibitionContent: '展览内容',
  //资讯
  releaseTime: '发布时间',
  details: '详情',
  //banner
  schedule: '立即预定',
  // 典藏
  locationOfExhibitionHall: '展厅位置',
  times: '时       代',
  timeSpecification: '规       格',
  source: '来       源',
  number: '编       号',
  collectDetails_details: '详       情',
  level: '级       别',
  //社教
  socialEducation_times: '时间',
  socialEducation_address: '地点',
  registrationTelephone: '报名电话',
  ageRequirement: '年龄要求',
  remainingTime: '剩余时间',
  briefIntroduction: '简介',
  eventDetails: '活动详情',
  //文创
  type: '类型',
  price: '价格',
  buy: '购买',
  dyf: '详情介绍',
  displaySection: '显示部分',
  showAll: '显示全部',
  //common
  viewDetails: '查看详情',
  //研究
  essentialInformation: '基本信息',
  bookName: '书名',
  author: '作者',
  publish: '出版',
  contentValidity: '内容简介',
  //home
  WeChat: '微信',
  microBlog: '微博',
  order: '预约',
  busRoutes: '公交路线',
  consultationTelephone: '咨询电话',
}


// WEBPACK FOOTER //
// ./src/locales/zh.js